import { Component, OnInit } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { Project } from '@src/app/models/project';

import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-compactprojectlist',
  templateUrl: './compactprojectlist.component.html',
  styleUrls: ['./compactprojectlist.component.css']
})
export class CompactprojectlistComponent implements OnInit{
  allProjectsList:Project[];
    constructor() { }
  
    ngOnInit(): void {
      this.allProjectsList = SessionHelper.getPortalProjectList() ? JSON.parse(SessionHelper.getPortalProjectList()) : [];
      //console.log(this.allProjectsList);
    }

}
